module.exports = __webpack_public_path__ + "img/MicrosoftTeams-image (6).dd4863ec.png";